import { useContext } from "react";
import { PluginspaceContext } from "../contexts/PluginspaceContext";

export function usePluginspace() {
    const value = useContext(PluginspaceContext);
    return value;
}